import { jsx as _jsx } from "react/jsx-runtime";
const sizeMap = {
    sm: 'nucleus-h-8 nucleus-w-8',
    base: 'nucleus-h-10 nucleus-w-10',
    lg: 'nucleus-h-12 nucleus-w-12',
};
/** Default avatar icon showing a generic user silhouette */
const defaultContent = (_jsx("svg", { className: 'nucleus-h-full nucleus-w-full nucleus-text-neutral-300', fill: 'currentColor', viewBox: '0 0 24 24', children: _jsx("path", { d: 'M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z' }) }));
export const Avatar = ({ size = 'base', children = defaultContent }) => {
    return (_jsx("span", { className: `nucleus-inline-block nucleus-overflow-hidden nucleus-bg-neutral-100 nucleus-rounded-full ${sizeMap[size]}`, children: children }));
};
//# sourceMappingURL=avatar.js.map